import { ChannelStat, ChannelStatsResponse } from '../../models/channels/types';
import ChannelService from '../../services/channel';
import { useEffect, useState } from 'react';

export const toChannelStat = ({
  last_updated: lastUpdated,
  posts_count: postsCount,
  posts_per_week: postsPerWeek,
  follower_count: followerCount,
  contributor_count: contributorCount,
}: ChannelStatsResponse['stats']): ChannelStat => ({
  postsCount,
  postsPerWeek,
  lastUpdated,
  followerCount,
  contributorCount,
});

// Fetches only the stats endpoint, for cards that render nothing else. Going
// through useChannelDetails would also request contributors and followers, and
// a failure in either of those would hide stats that loaded fine.
const useChannelStats = (channelId: string) => {
  const [fetching, setFetching] = useState(true);
  const [channelStats, setChannelStats] = useState<ChannelStat>();

  useEffect(() => {
    // The card stays mounted when the topic changes, so drop the previous
    // topic's stats and ignore any of its responses that land late.
    let cancelled = false;
    setFetching(true);
    setChannelStats(undefined);

    new ChannelService(channelId)
      .fetchStats()
      .then((response) => {
        if (!cancelled) setChannelStats(toChannelStat(response.data.stats));
      })
      .catch((err: unknown) => {
        console.error(err, 'Error fetching channel stats');
      })
      .finally(() => {
        if (!cancelled) setFetching(false);
      });

    return () => {
      cancelled = true;
    };
  }, [channelId]);

  return { fetching, channelStats };
};

export default useChannelStats;
